import BaseCanvasInjectable from '@src/slide/application/service/canvas-component/inject/base/base-canvas-injectable';
import { IPcCanvasInjectable } from '@src/slide/application/service/canvas-component/inject/pc/interface';
import { CustomConfig, StatusBarConfig } from '@src/slide/infrastructure/module/dependent/config/config-manager-constants';
import appConfigInstance from '@src/slide/infrastructure/module/dependent/config/tob/app-config';
import { TENANT_CONFIG } from '@src/slide/infrastructure/module/dependent/config/tob/constant';
import { isPreview } from '@src/slide/infrastructure/module/dependent/runtime-environment/drive-env';
import ENV from '@src/slide/infrastructure/module/dependent/runtime-environment/enviroment';
import { getQuery } from 'sutils';

export default class PcCanvasInjectable extends BaseCanvasInjectable implements IPcCanvasInjectable {
    private showToolbar = appConfigInstance.getConfig('toolbar') ?? true;
    private showTitleBar = appConfigInstance.getConfig('titlebar') ?? true;
    private showStatusBar = appConfigInstance.getConfig(StatusBarConfig.statusBar as any) ?? true;
    private showNote = appConfigInstance.getConfig(CustomConfig.showNote as any) ?? true;
    /**
     * 标题是否折叠处理。返回undefined表示未处理
     */
    public isHeaderFold(): boolean | undefined {
        // 预览态不展示header,等同于headerFold处理
        if (isPreview()) {
            return true;
        }
        // cac 配置不展示 header
        if (!this.showToolbar && !this.showTitleBar) {
            return true;
        }

        // 当 weboffice 中 hideTitlebar 与 hideToolbar 同时设置时，等同于隐藏工具栏操作
        if ((getQuery('hideTitlebar') && getQuery('hideToolbar'))) {
            return true;
        }
    }

    /**
     * 状态栏是否折叠处理。
     */
    public isStatusBarFold(): boolean {
        if (this.showStatusBar) {
            return false;
        }
        return true;
    }

    /**
     * 备注是否折叠处理。
     */
    public isNoteFold(): boolean {
        if (this.showNote) {
            return false;
        }
        return true;
    }

    public shouldShowTemplateRecommendation(): boolean {
        return !ENV.IS_LOCAL_EDIT;
    }

    public updateSlideName(slideName?: string): string| undefined {
        if (TENANT_CONFIG.TENANT_DOC_NAME) {
            return slideName?.replace(/腾讯文档/g, TENANT_CONFIG.TENANT_DOC_NAME);
        }
        return slideName;
    }
}
